const state = {
   results: [],
};

const getters = {
    hasResults: state => state.results.length > 0,
    results: state => state.results,
};

const mutations = {
    changeVisibility(state, bool) {
        state.visible = bool;
    },
    addResults(state, results) {
        state.results = results;
    },
    resetResults(state) {
        state.results = [];
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
}
